module.exports = "<span><h3 class=\"fragment\">Oh yeah...</h3><h3 class=\"fragment\">it also natively compiles to JavaScript.</h3></span><video class=\"fragment\" autoplay=\"autoplay\" loop=\"loop\" data-ignore=\"data-ignore\"><source src=\"../../../resources/images/much_excite.mp4\" type=\"video/mp4\"/></video>";


//////////////////
// WEBPACK FOOTER
// ./src/slides/07-javascript/01.pug
// module id = 338
// module chunks = 1